import { useState, useEffect, useMemo } from 'react';
import { RouterParam } from '../../helpers/routerParam';
import useGetParameter from '../../hooks/useGetParameter';

let timeout: NodeJS.Timeout;

const useGetPopupState = () => {
  const popupName = useGetParameter(RouterParam.Popup);
  const [mountedPopup, setMountedPopup] = useState(popupName);

  useEffect(() => {
    if (popupName) {
      timeout && clearTimeout(timeout);
      setMountedPopup(popupName);
    } else {
      timeout = setTimeout(() => {
        setMountedPopup(null);
      }, 300);
    }
  }, [popupName]);

  useEffect(() => {
    return () => {
      timeout && clearTimeout(timeout);
    };
  }, []);

  const isOpened = useMemo(() => Boolean(popupName), [popupName]);

  return {
    mountedPopup,
    isOpened,
  };
};

export default useGetPopupState;
